<template>
  <div class="content mb-5">
    <b-row class="mb-5">
      <b-col>
        <t-data-table
          data-test-id="devices-data-table"
          with-filter
          hoverable
          :filter-placeholder="$t('Search Devices')"
          :title="this.$t('All Devices')"
          :loading="loading"
          :fetching="fetching"
          :table-data="dataSet"
          :actions="tableActions"
          :server-items-length="serverItemsLength"
          user-role="customer"
          @on-export="onExport"
          @on-delete="onDelete"
          @on-row-clicked="onRowClicked"
          key-item="name"
          :searchExports="searchExports"
          @export-headers="exportedHeaders"
          @async-paginate="onSearch"
        />
      </b-col>
    </b-row>
  </div>
</template>

<route>
{
  "name": "Customer Environment Devices",
  "meta": {
    "authorize" : [1, 3, 4]
  }
}
</route>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  layout: "customer",
  data: function () {
    return {
      loading: false,
      fetching: false,
      currentHeaders: null,
      serverItemsLength: 0,
      dataOptions: {
        results: 10,
        page: 1,
        sortBy: "name",
        sortDesc: "asc",
        filter: null,
      },
      tableActions: {
        add: { enabled: false },
        export: { enabled: true },
        import: { enabled: false },
        delete: { enabled: true },
      },
      searchExports: ["name", "key", "status"],
      dataSet: {
        fields: [
          { value: "name", text: this.$t("Device Name"), sortable: true },
          { value: "user", text: this.$t("User"), sortable: true },
          { value: "os", text: this.$t("Agent"), sortable: true },
          {
            value: "last_contact",
            text: this.$t("Last Contact"),
          },
          {
            value: "device_exception",
            text: this.$t("Device Exception"),
          },
          {
            value: "version",
            text: this.$t("Version"),
          },

          { value: "key", text: this.$t("Device Key") },

          {
            value: "location",
            text: this.$t("Virtual Location"),
          },
          { value: "policyname", text: this.$t("Policy") },

          { value: "status", text: this.$t("Status") },
        ],
        items: [],
      },
    };
  },
  computed: {
    ...mapGetters("devices", ["userDevices", "serverTotal", "exportDevices"]),
    ...mapGetters("authentication", ["selectedUser"]),
  },
  watch: {
    userDevices() {
      this.dataSet.items = this.userDevices;
    },
    serverTotal: {
      handler() {
        this.serverItemsLength = this.serverTotal;
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
    ...mapActions("devices", [
      "fetchDevices",
      "deleteDevices",
      "fetchExportDevices",
    ]),
    ...mapActions("toast", ["displayToast"]),
    onRowClicked(item) {
      this.$router.push(`/customer/environment/devices/${item.id}`);
    },
    exportedHeaders(headers) {
      this.currentHeaders = headers;
    },
    async onExport() {
      try {
        this.fetching = true;
        await this.fetchExportDevices({
          id: this.selectedUser.id,
        });
      } finally {
        this.fetching = false;
      }

      if (this.exportDevices.length) {
        const exportData = this.exportDevices.map((res) => {
          let payload = {};
          this.currentHeaders.forEach((headers) => {
            return (payload[headers.value] = res[headers.value]);
          });

          return payload;
        });
        this.$downloadCSV(exportData, "Devices");
      } else {
        this.displayToast({
          title: this.$t("Failure"),
          message: this.$t("No Devices in table"),
          duration: 2000,
          variant: "danger",
        });
      }
    },
    async onDelete(devices) {
      try {
        this.loading = true;
        await this.deleteDevices({
          userId: this.selectedUser.id,
          devices,
        });
        this.displayToast({
          title: this.$t("Success"),
          message: this.$t("Deleted X X", {
            count: devices.length,
            item: this.$t("Device(s)"),
          }),
          duration: 2000,
          variant: "success",
        });
      } catch (err) {
        // stub console.error(err);
      } finally {
        this.loading = false;
      }
    },

    async onSearch(options) {
      if (options.itemsPerPage === undefined) return;
      if (options.itemsPerPage) {
        this.dataOptions.results = options.itemsPerPage;
      }
      if (options.page) {
        this.dataOptions.page = options.page;
      }
      if (options.sortBy) {
        this.dataOptions.sortBy = options.sortBy[0];
      }
      if (options.sortDesc) {
        this.dataOptions.sortDesc = options.sortDesc;
      }

      if (this.dataOptions.filter !== options.filter) {
        this.dataOptions.page = 1;
      }
      this.dataOptions.filter = options.filter;

      try {
        await this.fetchDevices({
          id: this.selectedUser.id,
          policyId: null,
          locationId: null,
          ...this.dataOptions,
        });
      } finally {
        this.loading = false;
      }
    },
  },
  async created() {
    this.setPageTitle(this.$t("Devices"));
    this.setPageSubtitle([
      this.$t(
        "Devices are automatically created when WebTitan OTG 2 is installed on an endpoint, such as a remote laptop or Chromebook. Devices can be configured to send DNS requests to WebTitan for filtering."
      ),
    ]);
    this.loading = false;
  },
};
</script>
